import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { StatsCards } from "@/components/dashboard/StatsCards";
import { RecordingsTable } from "@/components/dashboard/RecordingsTable";
import { useOfflineDetection } from "@/hooks/useOfflineDetection";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const LANGUAGES = [
  { code: "zh-TW", label: "繁體中文" },
  { code: "zh-CN", label: "简体中文" },
  { code: "en", label: "English" },
  { code: "ja", label: "日本語" },
  { code: "ko", label: "한국어" },
];

export default function Dashboard() {
  const { t, i18n } = useTranslation();
  const { isOffline } = useOfflineDetection();

  return (
    <div className="space-y-8">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold text-foreground">
            {t("dashboard.title")}
          </h1>
          <p className="text-muted-foreground mt-1">
            {t("dashboard.subtitle")}
          </p>
        </div>
        <div className="flex items-center gap-3">
          <Link
            to="/editor/new"
            className="inline-flex items-center justify-center gap-2 px-4 py-[6px] bg-[#FFD93D] text-black font-bold rounded-xl border-2 border-black shadow-[4px_4px_0_#000] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-[2px_2px_0_#000] transition-all"
          >
            <Plus className="h-5 w-5" />
            {t("dashboard.createScript")}
          </Link>
          <Select
            value={i18n.language}
            onValueChange={(value) => {
               i18n.changeLanguage(value);
               localStorage.setItem("language", value);
            }}
          >
            <SelectTrigger className="w-[150px] bg-background border-2 border-black shadow-[2px_2px_0_#000]">
              <SelectValue placeholder="Language" />
            </SelectTrigger>
            <SelectContent>
              {LANGUAGES.map((lang) => (
                <SelectItem key={lang.code} value={lang.code}>
                  {lang.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      </div>

      {/* Stats Cards - hide when offline */}
      {!isOffline && <StatsCards />}

      {/* Recordings Table */}
      {!isOffline && <RecordingsTable />}
    </div>
  );
}
